export const AuthPatterns = () => {
  return (
    <svg
      width="720"
      height="920"
      viewBox="0 0 720 920"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-390.015 229.604C-497.653 -160.441 -98.9231 -200.143 188.828 -82.3695C356.717 -21.8003 466.973 -210.166 674.955 -134.992C882.938 -59.8172 633.61 176.982 951.848 298.514C1270.09 420.046 1114.73 963.807 836.58 970.071C558.435 976.336 634.862 1067.8 356.717 1277.03C78.5718 1486.27 -390.015 1195.59 -273.495 888.632C-156.975 581.67 -273.496 651.833 -390.015 229.604Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M208.619 533.155C196.2 496.005 254.371 436.074 301.146 461.651C343.979 485.072 387.596 469.276 416.413 479.717C492.277 507.206 464.371 521.757 498.284 554.404C539.552 594.132 559.244 698.161 464.371 698.161C386.343 698.161 409.69 736.058 351.262 752.85C292.833 769.642 226.571 741.059 226.571 665.805C226.571 637.546 229.304 595.028 208.619 533.155Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M-335.602 255.304C-434.584 -102.659 -66.8135 -144.2 199.03 -34.808C355.551 22.3841 459.749 -150.293 651.443 -81.0038C847.415 -10.1645 618.216 206.43 910.607 319.882C1203.67 433.977 1064.22 937.762 802.735 943.457C542.782 949.152 614.384 1035.75 356.213 1227.49C98.0421 1419.23 -333.97 1152.38 -228.042 866.481C-122.115 584.855 -227.795 644.774 -335.602 255.304Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M-281.188 281.006C-371.513 -44.8757 -34.7027 -88.2556 209.234 12.7546C354.386 66.5696 452.526 -90.4198 627.933 -27.015C811.893 39.4893 602.824 235.88 869.367 341.251C1137.25 447.909 1013.71 911.719 768.891 916.844C527.131 921.97 593.907 1003.69 355.71 1177.94C117.514 1352.18 -277.923 1109.16 -182.588 844.33C-87.2537 588.041 -182.093 637.716 -281.188 281.006Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M-226.772 306.709C-308.441 12.9088 -2.59111 -32.3102 219.439 60.3185C353.222 110.757 445.304 -30.5448 604.423 26.9752C776.373 89.1444 587.433 265.331 828.128 362.621C1070.83 461.843 963.209 885.677 735.048 890.233C511.48 894.789 573.431 971.643 355.208 1128.39C136.986 1285.14 -221.876 1065.95 -137.134 822.18C-52.3919 591.228 -136.39 630.66 -226.772 306.709Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M-172.359 332.414C-245.372 70.6953 29.5186 23.6372 229.642 107.884C352.056 154.945 438.08 29.3322 580.911 80.9674C740.85 138.802 572.04 294.783 786.887 383.993C1004.41 475.778 912.703 859.637 701.203 863.623C495.827 867.61 552.953 939.594 354.704 1078.85C156.456 1218.11 -165.83 1022.74 -91.6812 800.033C-17.532 594.417 -90.6884 623.605 -172.359 332.414Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M-117.944 359.422C-182.301 129.784 61.6293 80.8868 239.846 156.753C350.891 200.436 430.857 90.5114 557.4 136.262C705.329 189.761 556.648 325.538 745.647 406.668C937.989 491.016 862.198 834.899 667.359 838.316C480.176 841.733 532.475 908.847 354.202 1030.61C175.928 1152.37 -109.784 980.828 -46.2275 779.188C17.3289 598.908 -44.9861 617.853 -117.944 359.422Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M-63.5275 387.969C-119.228 190.413 93.7424 139.677 250.052 207.161C349.729 247.468 423.636 153.231 533.892 193.097C669.81 242.261 541.258 357.833 704.41 430.883C871.573 507.794 811.695 811.701 633.517 814.549C464.526 817.396 512.001 879.641 353.701 983.908C195.402 1088.17 -53.7352 940.458 -0.771446 759.883C52.1923 604.94 0.71846 613.641 -63.5275 387.969Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M-9.10888 416.603C-56.1531 251.128 125.857 198.552 260.26 257.655C348.568 294.585 416.417 216.036 510.385 250.017C634.292 294.846 525.87 390.214 663.174 455.183C805.158 524.658 761.194 788.589 599.677 790.867C448.879 793.145 491.528 850.521 353.203 937.293C214.877 1024.06 2.31547 900.175 44.6864 740.664C87.0574 611.057 46.4249 609.515 -9.10888 416.603Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M45.3105 445.36C6.92253 311.966 157.973 257.552 270.469 308.273C347.408 341.826 409.199 278.965 486.88 307.061C598.776 347.555 510.482 422.719 621.939 479.607C738.744 541.645 710.694 765.601 565.838 767.31C433.232 769.018 471.056 821.524 352.705 890.801C234.354 960.077 58.3668 860.015 90.145 721.568C121.923 617.298 92.132 605.512 45.3105 445.36Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M99.7338 474.298C70.002 372.986 190.093 316.732 280.681 359.072C346.252 389.248 401.985 342.075 463.378 364.286C563.263 400.445 495.099 455.405 580.708 504.213C672.333 558.814 660.198 742.794 532.003 743.933C417.59 745.072 450.587 792.709 352.211 844.491C253.834 896.272 114.422 820.036 135.608 702.654C156.793 623.721 137.843 601.691 99.7338 474.298Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
      <path
        d="M154.166 503.512C133.09 434.281 222.221 376.189 290.903 410.147C345.104 436.946 394.78 405.461 439.884 421.788C527.759 453.612 479.724 488.367 539.485 529.094C605.932 576.259 609.71 720.263 498.176 720.833C401.955 721.402 430.128 764.169 351.725 798.456C273.323 832.743 170.486 780.333 181.079 684.015C191.671 630.419 183.563 598.145 154.166 503.512Z"
        stroke="#8139C3"
        strokeOpacity="0.03"
        strokeWidth="7.51744"
      />
    </svg>
  );
};

export const LogoSmall = () => {
  return (
    <svg
      width="120"
      height="20"
      viewBox="0 0 120 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.24 4.78C8.54667 4.78 9.61333 5.26667 10.44 6.24C11.2667 7.2 11.68 8.46667 11.68 10.04C11.68 11.6 11.26 12.8667 10.42 13.84C9.58 14.8 8.5 15.28 7.18 15.28C6.43333 15.28 5.78 15.1133 5.22 14.78C4.67333 14.4333 4.28667 14.0133 4.06 13.52V15H0.14V0.96H4.06V6.54C4.28667 6.03333 4.68 5.61333 5.24 5.28C5.81333 4.94667 6.48 4.78 7.24 4.78ZM4.42 11.58C4.76667 11.9667 5.21333 12.16 5.76 12.16C6.30667 12.16 6.75333 11.96 7.1 11.56C7.44667 11.16 7.62 10.6533 7.62 10.04C7.62 9.41333 7.44667 8.90667 7.1 8.52C6.75333 8.13333 6.30667 7.94 5.76 7.94C5.21333 7.94 4.76667 8.13333 4.42 8.52C4.07333 8.90667 3.9 9.41333 3.9 10.04C3.9 10.6667 4.07333 11.18 4.42 11.58ZM16.8055 15.28C15.5521 15.28 14.6255 14.9133 14.0255 14.18C13.4388 13.4467 13.1455 12.4267 13.1455 11.12V5.06H17.1255V10.26C17.1255 11.42 17.5721 12 18.4655 12C19.4121 12 19.8855 11.38 19.8855 10.14V5.06H23.8255V15H19.8855V13.52C19.3655 14.6933 18.3388 15.28 16.8055 15.28ZM32.7575 5.06H36.6775V14.34C36.6775 15.9533 36.1775 17.18 35.1775 18.02C34.2575 18.7667 32.9508 19.14 31.2575 19.14C29.4708 19.14 28.1508 18.8 27.2975 18.12C26.9108 17.8 26.5908 17.4 26.3375 16.92C26.0975 16.4533 25.9775 15.9733 25.9775 15.48H29.8975C29.9375 16.16 30.3908 16.5 31.2575 16.5C32.2575 16.5 32.7575 15.9667 32.7575 14.9V13.08C32.1975 14.2133 31.1642 14.78 29.6575 14.78C27.2042 14.78 25.9775 13.3667 25.9775 10.54V5.06H29.8975V10.08C29.8975 11.24 30.3508 11.82 31.2575 11.82C32.2575 11.82 32.7575 11.1333 32.7575 9.76V5.06ZM38.9486 15V5.06H42.8686V6.52C43.3486 5.36 44.3286 4.78 45.8086 4.78C47.3686 4.78 48.4019 5.40667 48.9086 6.66C49.1886 6.07333 49.6153 5.61333 50.1886 5.28C50.7619 4.94667 51.4219 4.78 52.1686 4.78C54.5019 4.78 55.6686 6.16 55.6686 8.92V15H51.6686V9.64C51.6686 8.58667 51.2886 8.06 50.5286 8.06C49.6886 8.06 49.2686 8.71333 49.2686 10.02V15H45.2686V9.64C45.2686 9.08 45.1753 8.68 44.9886 8.44C44.8153 8.18667 44.5353 8.06 44.1486 8.06C43.7219 8.06 43.4019 8.21333 43.1886 8.52C42.9753 8.81333 42.8686 9.31333 42.8686 10.02V15H38.9486ZM68.3548 9.52C68.3548 10.0133 68.3215 10.5 68.2548 10.98H60.9348C60.9615 11.5 61.1415 11.9067 61.4748 12.2C61.8215 12.4933 62.2748 12.64 62.8348 12.64C63.6748 12.64 64.1948 12.3933 64.3948 11.9H68.1948C68.0215 12.9533 67.4482 13.7933 66.4748 14.42C65.5015 15.0333 64.2882 15.34 62.8348 15.34C61.0215 15.34 59.5948 14.88 58.5548 13.96C57.5282 13.0267 57.0148 11.72 57.0148 10.04C57.0148 8.38667 57.5348 7.08667 58.5748 6.14C59.6148 5.18 61.0082 4.7 62.7548 4.7C64.4082 4.7 65.7548 5.14667 66.7948 6.04C67.8348 6.93333 68.3548 8.09333 68.3548 9.52ZM60.9348 8.82H64.4348C64.4215 8.27333 64.2682 7.84667 63.9748 7.54C63.6815 7.23333 63.2615 7.08 62.7148 7.08C62.1815 7.08 61.7548 7.24 61.4348 7.56C61.1282 7.88 60.9615 8.3 60.9348 8.82Z"
        fill="#121212"
      />
      <path
        d="M71.7684 4.72C71.1418 4.72 70.6218 4.51333 70.2084 4.1C69.7951 3.67333 69.5884 3.16667 69.5884 2.58C69.5884 1.98 69.7951 1.47333 70.2084 1.06C70.6218 0.646666 71.1418 0.439999 71.7684 0.439999C72.3818 0.439999 72.8951 0.646666 73.3084 1.06C73.7351 1.47333 73.9484 1.98 73.9484 2.58C73.9484 3.16667 73.7351 3.67333 73.3084 4.1C72.8951 4.51333 72.3818 4.72 71.7684 4.72ZM70.0484 18.92C69.4618 18.92 68.9151 18.8467 68.4084 18.7V15.96C68.6484 16 68.8618 16.02 69.0484 16.02C69.5551 16.02 69.8084 15.72 69.8084 15.12V5.06H73.7284V15.24C73.7284 16.48 73.4151 17.4067 72.7884 18.02C72.1618 18.6333 71.2484 18.9333 70.0484 18.92ZM80.9394 15.34C79.1927 15.34 77.7927 14.8533 76.7394 13.88C75.686 12.8933 75.1594 11.6067 75.1594 10.02C75.1594 8.43333 75.686 7.15333 76.7394 6.18C77.7927 5.19333 79.1927 4.7 80.9394 4.7C82.6994 4.7 84.106 5.19333 85.1594 6.18C86.2127 7.15333 86.7394 8.43333 86.7394 10.02C86.7394 11.6067 86.2127 12.8933 85.1594 13.88C84.106 14.8533 82.6994 15.34 80.9394 15.34ZM80.9394 12.12C81.5127 12.12 81.966 11.9267 82.2994 11.54C82.6327 11.1533 82.7994 10.6467 82.7994 10.02C82.7994 9.39333 82.6327 8.88667 82.2994 8.5C81.966 8.11333 81.5127 7.92 80.9394 7.92C80.3794 7.92 79.926 8.12 79.5794 8.52C79.246 8.90667 79.0794 9.40667 79.0794 10.02C79.0794 10.6333 79.246 11.14 79.5794 11.54C79.926 11.9267 80.3794 12.12 80.9394 12.12ZM88.1869 15V0.999999H92.1069V15H88.1869ZM94.3783 15V0.999999H98.2983V15H94.3783ZM105.51 15.34C103.763 15.34 102.363 14.8533 101.31 13.88C100.256 12.8933 99.7297 11.6067 99.7297 10.02C99.7297 8.43333 100.256 7.15333 101.31 6.18C102.363 5.19333 103.763 4.7 105.51 4.7C107.27 4.7 108.676 5.19333 109.73 6.18C110.783 7.15333 111.31 8.43333 111.31 10.02C111.31 11.6067 110.783 12.8933 109.73 13.88C108.676 14.8533 107.27 15.34 105.51 15.34ZM105.51 12.12C106.083 12.12 106.536 11.9267 106.87 11.54C107.203 11.1533 107.37 10.6467 107.37 10.02C107.37 9.39333 107.203 8.88667 106.87 8.5C106.536 8.11333 106.083 7.92 105.51 7.92C104.95 7.92 104.496 8.12 104.15 8.52C103.816 8.90667 103.65 9.40667 103.65 10.02C103.65 10.6333 103.816 11.14 104.15 11.54C104.496 11.9267 104.95 12.12 105.51 12.12ZM118.46 3.48C117.634 3.48 117.22 3.81333 117.22 4.48V5.06H119.28V8.06H117.22V15H113.32V8.06H111.74V5.06H113.32V4.52C113.32 3.82667 113.427 3.22667 113.64 2.72C113.867 2.2 114.174 1.80667 114.56 1.54C114.947 1.26 115.36 1.06 115.8 0.94C116.24 0.82 116.72 0.76 117.24 0.76C118.08 0.76 118.76 0.846666 119.28 1.02V3.56C118.854 3.50667 118.58 3.48 118.46 3.48Z"
        fill="#EFA92F"
      />
    </svg>
  );
};

export const FullLogo = () => {
  return (
    <svg
      width="123"
      height="25"
      viewBox="0 0 123 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4721 0C15.9147 0 19.0364 1.40351 21.2974 3.65497C23.5585 5.92105 24.9443 9.03509 24.9443 12.5C24.9443 15.9503 23.5439 19.0789 21.2974 21.345C19.0364 23.6111 15.9293 25 12.4721 25C9.02953 25 5.90785 23.5965 3.64682 21.345C1.38579 19.0789 0 15.9649 0 12.5C0 9.04971 1.40038 5.92105 3.64682 3.65497C5.90785 1.38889 9.01494 0 12.4721 0ZM19.0218 15C19.0218 11.652 16.8191 9.29825 13.9454 9.29825C13.9017 9.29825 13.8579 9.29825 13.7996 9.29825V8.17251V5.19006C13.7996 4.07895 13.1577 3.53801 12.2533 3.53801H11.4364V8.62573V10.0146V10.3363V12.0468C11.4364 12.2368 11.5969 12.3977 11.7865 12.3977C11.8595 12.3977 11.9324 12.3684 11.9907 12.3392C12.3846 12.0029 12.866 11.7982 13.4057 11.7982C15.127 11.7982 16.1044 12.7193 16.1044 15.4825C16.1044 17.3099 15.0978 18.655 13.6975 18.655C12.1366 18.655 11.1884 17.7047 10.9259 15.4678C10.8967 15.2632 10.8967 14.9854 10.8967 14.7661V11.0234V10.0292V7.7193C10.8967 6.38889 10.1382 5.76023 9.04412 5.76023H8.08136V15.3655C8.08136 18.7719 10.5174 21.1404 13.4057 21.1404C16.8483 21.1404 19.0218 18.3918 19.0218 14.9854V15ZM20.8598 4.09357C18.7155 1.94444 15.7543 0.614035 12.4721 0.614035C9.18999 0.614035 6.22877 1.94444 4.08444 4.09357C1.94011 6.24269 0.612666 9.21053 0.612666 12.5C0.612666 15.7895 1.94011 18.7573 4.08444 20.9064C6.22877 23.0556 9.18999 24.386 12.4721 24.386C15.7543 24.386 18.7155 23.0556 20.8598 20.9064C23.0041 18.7573 24.3316 15.7895 24.3316 12.5C24.3316 9.21053 23.0041 6.24269 20.8598 4.09357Z"
        fill="#EFA92F"
      />
      <path
        d="M35.3303 9.24051C36.5557 9.24051 37.5622 9.6791 38.3207 10.5417C39.0793 11.4189 39.4731 12.5592 39.4731 13.9773C39.4731 15.3809 39.0793 16.5212 38.3061 17.3984C37.5184 18.2756 36.5119 18.7142 35.272 18.7142C34.6301 18.7142 34.0467 18.568 33.5361 18.2902C33.0255 17.9978 32.6609 17.6469 32.4129 17.2083V18.4803H29.5684V5.38086H32.4129V10.761C32.6463 10.3078 33.0401 9.94226 33.5653 9.66448C34.105 9.37209 34.6885 9.24051 35.3303 9.24051ZM34.4405 16.3604C35.0678 16.3604 35.5783 16.1411 35.9722 15.7025C36.366 15.2639 36.5703 14.6937 36.5703 13.992C36.5703 13.2902 36.366 12.7347 35.9722 12.2961C35.5783 11.8575 35.0678 11.6382 34.4405 11.6382C33.7987 11.6382 33.2735 11.8575 32.8797 12.2961C32.4858 12.7347 32.2816 13.3048 32.2816 13.992C32.2816 14.7083 32.4858 15.2785 32.8943 15.7171C33.3027 16.1557 33.8133 16.375 34.4551 16.375L34.4405 16.3604Z"
        fill="black"
      />
      <path
        d="M43.3535 18.728C42.2886 18.728 41.4717 18.4064 40.8882 17.7631C40.3193 17.1198 40.0276 16.2134 40.0276 15.0438V9.4736H42.9159V14.4005C42.9159 15.6724 43.4118 16.3011 44.4038 16.3011C45.5562 16.3011 46.1397 15.6286 46.1397 14.2982V9.45898H48.9696V18.4648H46.1397V17.1783C45.5999 18.2017 44.6809 18.7134 43.3389 18.7134L43.3535 18.728Z"
        fill="black"
      />
      <path
        d="M56.3652 9.48828H59.2098V18.2164C59.2098 19.6052 58.7867 20.6871 57.9261 21.462C57.1238 22.1637 56.0152 22.5146 54.6294 22.5146C53.1706 22.5146 52.0766 22.2076 51.318 21.5789C50.5887 20.9503 50.2094 20.1608 50.1948 19.2105H53.0685C53.1269 20.0146 53.652 20.424 54.6294 20.424C55.7818 20.424 56.3652 19.7514 56.3652 18.4064V17.0029C55.8401 17.9971 54.8919 18.4941 53.5207 18.4941C52.4121 18.4941 51.5806 18.1579 51.0263 17.4854C50.472 16.8128 50.1948 15.8918 50.1948 14.7222V9.48828H53.0393V14.2836C53.0393 15.5848 53.5645 16.228 54.6294 16.228C55.1837 16.228 55.6213 16.0234 55.913 15.614C56.2048 15.2047 56.3652 14.6491 56.3652 13.9473V9.48828Z"
        fill="black"
      />
      <path
        d="M60.5082 18.48V9.47412H63.3528V10.7753C63.557 10.3075 63.8779 9.94196 64.3301 9.64956C64.7823 9.35716 65.3075 9.22559 65.9201 9.22559C67.3351 9.22559 68.2687 9.78114 68.7355 10.8923C68.9835 10.3952 69.3627 9.98582 69.8733 9.69342C70.3838 9.3864 70.9673 9.24021 71.6092 9.24021C73.7389 9.24021 74.7892 10.4537 74.7892 12.8952V18.48H71.9155V13.4215C71.9155 12.2373 71.4633 11.6525 70.5735 11.6525C69.5669 11.6525 69.071 12.3835 69.071 13.8601V18.4946H66.1973V13.4215C66.1973 12.2519 65.7597 11.6671 64.8698 11.6671C64.3739 11.6671 63.9946 11.8279 63.732 12.1642C63.4695 12.5004 63.3382 13.0706 63.3382 13.8747V18.5092H60.4937L60.5082 18.48Z"
        fill="black"
      />
      <path
        d="M84.8398 13.5092C84.8398 13.8893 84.8107 14.2987 84.7669 14.7665H78.1297C78.1589 15.3513 78.3485 15.8045 78.7278 16.1262C79.107 16.4478 79.603 16.6086 80.2302 16.6086C81.1055 16.6086 81.6598 16.3308 81.9078 15.7753H84.7085C84.5773 16.6525 84.0959 17.3835 83.2644 17.939C82.4329 18.4946 81.4264 18.7724 80.2302 18.7724C78.6986 18.7724 77.5024 18.3484 76.6126 17.5004C75.7374 16.6525 75.2852 15.4829 75.2852 13.9917C75.2852 12.5297 75.7228 11.3601 76.6126 10.5121C77.4878 9.66418 78.6694 9.22559 80.1281 9.22559C81.5139 9.22559 82.6517 9.62032 83.527 10.4244C84.4022 11.2285 84.8252 12.2519 84.8252 13.5238L84.8398 13.5092ZM78.1297 12.9829H82.0245C82.0099 12.3835 81.8494 11.9303 81.5285 11.594C81.2076 11.2724 80.7408 11.1116 80.1281 11.1116C79.5155 11.1116 79.0341 11.287 78.684 11.6232C78.3339 11.9595 78.1443 12.4127 78.1297 12.9829Z"
        fill="black"
      />
      <path
        d="M88.0343 8.17289C87.6988 8.50914 87.2757 8.66996 86.7652 8.66996C86.2546 8.66996 85.8316 8.50914 85.5107 8.17289C85.1752 7.83663 85.0147 7.42727 85.0147 6.94482C85.0147 6.44774 85.1752 6.02376 85.5107 5.68751C85.8462 5.35125 86.2546 5.19043 86.7652 5.19043C87.2757 5.19043 87.6988 5.36587 88.0343 5.70213C88.3698 6.03838 88.5302 6.46236 88.5302 6.94482C88.5302 7.42727 88.3698 7.83663 88.0343 8.17289ZM85.2773 22.3249C84.7375 22.3249 84.2853 22.2665 83.9207 22.1349V19.9273C84.1249 19.9711 84.3583 20.0004 84.6063 20.0004C85.0876 20.0004 85.3356 19.708 85.3356 19.1378V9.45944H88.1801V19.4887C88.1801 20.4243 87.9322 21.1261 87.4362 21.5939C86.9402 22.0618 86.2254 22.3103 85.2773 22.3103V22.3249Z"
        fill="#EFA92F"
      />
      <path
        d="M97.3846 17.4127C96.4802 18.3045 95.2694 18.7577 93.7669 18.7577C92.2499 18.7577 91.0391 18.3045 90.1347 17.4127C89.2303 16.5209 88.7781 15.3659 88.7781 13.977C88.7781 12.5882 89.2303 11.4332 90.1347 10.556C91.0391 9.66418 92.2499 9.22559 93.7669 9.22559C95.284 9.22559 96.4948 9.66418 97.3846 10.556C98.289 11.4478 98.7412 12.5882 98.7412 13.977C98.7412 15.3659 98.289 16.5209 97.3846 17.4127ZM93.7669 16.3308C94.4234 16.3308 94.9485 16.1115 95.3278 15.673C95.707 15.2344 95.9113 14.6642 95.9113 13.977C95.9113 13.2753 95.7216 12.7197 95.3278 12.2811C94.9485 11.8425 94.4234 11.6232 93.7669 11.6232C93.0959 11.6232 92.5708 11.8425 92.1915 12.2811C91.8122 12.7197 91.6226 13.2899 91.6226 13.977C91.6226 14.6788 91.8122 15.2344 92.1915 15.673C92.5708 16.1115 93.0959 16.3308 93.7669 16.3308Z"
        fill="#EFA92F"
      />
      <path
        d="M99.3247 18.4794V5.40918H102.169V18.4794H99.3247Z"
        fill="#EFA92F"
      />
      <path
        d="M103.468 18.4794V5.40918H106.312V18.4794H103.468Z"
        fill="#EFA92F"
      />
      <path
        d="M115.517 17.4127C114.612 18.3045 113.402 18.7577 111.899 18.7577C110.382 18.7577 109.171 18.3045 108.267 17.4127C107.363 16.5209 106.91 15.3659 106.91 13.977C106.91 12.5882 107.363 11.4332 108.267 10.556C109.171 9.66418 110.382 9.22559 111.899 9.22559C113.416 9.22559 114.627 9.66418 115.517 10.556C116.421 11.4478 116.874 12.5882 116.874 13.977C116.874 15.3659 116.421 16.5209 115.517 17.4127ZM111.899 16.3308C112.556 16.3308 113.081 16.1115 113.46 15.673C113.839 15.2344 114.044 14.6642 114.044 13.977C114.044 13.2753 113.854 12.7197 113.46 12.2811C113.081 11.8425 112.556 11.6232 111.899 11.6232C111.228 11.6232 110.703 11.8425 110.324 12.2811C109.945 12.7197 109.755 13.2899 109.755 13.977C109.755 14.6788 109.945 15.2344 110.324 15.673C110.703 16.1115 111.228 16.3308 111.899 16.3308Z"
        fill="#EFA92F"
      />
      <path
        d="M122.212 7.42641C121.337 7.42641 120.914 7.80653 120.914 8.56676V9.48781H123V11.7539H120.914V18.4937H118.069V11.7539H116.465V9.48781H118.069V8.61062C118.069 7.95273 118.172 7.38255 118.39 6.91471C118.595 6.44688 118.886 6.096 119.222 5.8767C119.572 5.6574 119.922 5.49658 120.272 5.39425C120.622 5.29191 120.987 5.24805 121.366 5.24805C122.023 5.24805 122.577 5.32115 123 5.45273V7.48489C122.942 7.48489 122.81 7.47027 122.635 7.45565C122.46 7.44103 122.314 7.42641 122.212 7.42641Z"
        fill="#EFA92F"
      />
    </svg>
  );
};

export const BackArrow = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 25}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7071 7.20711C13.0976 6.81658 13.0976 6.18342 12.7071 5.79289C12.3166 5.40237 11.6834 5.40237 11.2929 5.79289L5.29289 11.7929C4.91431 12.1715 4.90107 12.7811 5.26285 13.1757L10.7628 19.1757C11.136 19.5828 11.7686 19.6103 12.1757 19.2372C12.5828 18.864 12.6103 18.2314 12.2372 17.8243L7.38414 12.5301L12.7071 7.20711Z"
        fill="#2A2A2A"
      />
      <path
        opacity="0.3"
        d="M19.7071 7.20711C20.0976 6.81658 20.0976 6.18342 19.7071 5.79289C19.3166 5.40237 18.6834 5.40237 18.2929 5.79289L12.2929 11.7929C11.9143 12.1715 11.9011 12.7811 12.2628 13.1757L17.7628 19.1757C18.136 19.5828 18.7686 19.6103 19.1757 19.2372C19.5828 18.864 19.6103 18.2314 19.2372 17.8243L14.3841 12.5301L19.7071 7.20711Z"
        fill="#2A2A2A"
      />
    </svg>
  );
};

export const HomeIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 20}
      height={props?.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Stockholm-icons / Layout / Layout-4-blocks">
        <g id="Group">
          <g id="Group 2">
            <rect
              id="Rectangle 7"
              x="4"
              y="4"
              width="7"
              height="7"
              rx="1.5"
              fill="currentColor"
            />
            <path
              id="Combined Shape"
              opacity="0.3"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13 5.5C13 4.67157 13.6716 4 14.5 4H18.5C19.3284 4 20 4.67157 20 5.5V9.5C20 10.3284 19.3284 11 18.5 11H14.5C13.6716 11 13 10.3284 13 9.5V5.5ZM4 14.5C4 13.6716 4.67157 13 5.5 13H9.5C10.3284 13 11 13.6716 11 14.5V18.5C11 19.3284 10.3284 20 9.5 20H5.5C4.67157 20 4 19.3284 4 18.5V14.5ZM14.5 13C13.6716 13 13 13.6716 13 14.5V18.5C13 19.3284 13.6716 20 14.5 20H18.5C19.3284 20 20 19.3284 20 18.5V14.5C20 13.6716 19.3284 13 18.5 13H14.5Z"
              fill="currentColor"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UsersIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 20}
      height={props?.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16675 5.83333C4.16675 7.67428 5.65913 9.16667 7.50008 9.16667C9.34103 9.16667 10.8334 7.67428 10.8334 5.83333C10.8334 3.99238 9.34103 2.5 7.50008 2.5C5.65913 2.5 4.16675 3.99238 4.16675 5.83333ZM12.5001 9.16667C12.5001 10.5474 13.6194 11.6667 15.0001 11.6667C16.3808 11.6667 17.5001 10.5474 17.5001 9.16667C17.5001 7.78595 16.3808 6.66667 15.0001 6.66667C13.6194 6.66667 12.5001 7.78595 12.5001 9.16667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.48612 10.833C3.55159 10.833 0.323549 12.8551 0.00054307 16.8323C-0.0170515 17.049 0.39726 17.4997 0.606252 17.4997H14.3722C14.9983 17.4997 15.008 16.9959 14.9983 16.833C14.7541 12.744 11.476 10.833 7.48612 10.833ZM19.5466 17.4997L16.3333 17.4997C16.3333 15.6239 15.7136 13.8929 14.6677 12.5002C17.5064 12.5312 19.8243 13.9665 19.9987 16.9997C20.0058 17.1218 19.9987 17.4997 19.5466 17.4997Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SettingsIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 20}
      height={props?.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 2.5C3.99238 2.5 2.5 3.99238 2.5 5.83333C2.5 7.67428 3.99238 9.16667 5.83333 9.16667H14.1667C16.0076 9.16667 17.5 7.67428 17.5 5.83333C17.5 3.99238 16.0076 2.5 14.1667 2.5H5.83333ZM7.5 5.83333C7.5 6.75381 6.75381 7.5 5.83333 7.5C4.91286 7.5 4.16667 6.75381 4.16667 5.83333C4.16667 4.91286 4.91286 4.16667 5.83333 4.16667C6.75381 4.16667 7.5 4.91286 7.5 5.83333Z"
        fill="currentColor"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 10.833C3.99238 10.833 2.5 12.3254 2.5 14.1663C2.5 16.0073 3.99238 17.4997 5.83333 17.4997H14.1667C16.0076 17.4997 17.5 16.0073 17.5 14.1663C17.5 12.3254 16.0076 10.833 14.1667 10.833H5.83333ZM15.8333 14.1663C15.8333 15.0868 15.0871 15.833 14.1667 15.833C13.2462 15.833 12.5 15.0868 12.5 14.1663C12.5 13.2459 13.2462 12.4997 14.1667 12.4997C15.0871 12.4997 15.8333 13.2459 15.8333 14.1663Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownArrow = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5287 5.52892C11.789 5.26857 12.2111 5.26857 12.4715 5.52892C12.7318 5.78927 12.7318 6.21138 12.4715 6.47173L8.47149 10.4717C8.2191 10.7241 7.81271 10.7329 7.5496 10.4918L3.5496 6.82509C3.27819 6.5763 3.25985 6.15459 3.50865 5.88317C3.75744 5.61176 4.17915 5.59343 4.45056 5.84222L7.98003 9.07757L11.5287 5.52892Z"
        fill={props?.color ?? "currentColor"}
      />
    </svg>
  );
};

export const StatGraph = (props: any) => {
  return (
    <svg
      width="58"
      height="26"
      viewBox="0 0 58 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M57 23.9471C57 23.9471 54.1648 16.8975 52.6212 16.8975C51.0776 16.8975 50.8672 9.64918 49.2128 9.64918C47.5584 9.64918 47.152 16.4824 45.0892 16.4824C43.0264 16.4824 42.6824 1 41.428 1C40.1736 1 40.7328 9.71998 38.4656 9.64957C36.1984 9.57916 36.4376 7.49397 33.6776 7.49397C30.9176 7.49397 25.7248 19.0779 22.7036 19.0779C19.6824 19.0779 20.3892 16.4831 18.1836 16.4831C15.978 16.4831 16.8844 24.4643 12.278 23.9475C7.67159 23.4307 9.198 19.3039 7.3744 19.0779C5.984 18.9055 6.4736 23.9475 5.2332 23.9475C3.99281 23.9475 4.2948 21.8987 3.3932 21.8987C2.4916 21.8987 2.8104 25.6215 1 24.9095"
        stroke={props?.stroke ?? "black"}
        strokeWidth="0.976194"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MyPageIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 20}
      height={props?.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.3"
        x="1.66675"
        y="1.66699"
        width="16.6667"
        height="16.6667"
        rx="8.33333"
        fill={props?.fill ?? "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14005 12.1287C4.88475 11.7457 4.98823 11.2283 5.37117 10.9731C5.75411 10.7178 6.2715 10.8212 6.5268 11.2042C7.49099 12.6505 8.6287 13.3331 10.0001 13.3331C11.3715 13.3331 12.5092 12.6505 13.4734 11.2042C13.7287 10.8212 14.2461 10.7178 14.629 10.9731C15.0119 11.2283 15.1154 11.7457 14.8601 12.1287C13.6021 14.0157 11.962 14.9998 10.0001 14.9998C8.03815 14.9998 6.39807 14.0157 5.14005 12.1287Z"
        fill={props?.fill ?? "currentColor"}
      />
    </svg>
  );
};

export const PlusIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="11" width="16" height="2" rx="1" fill="#2A2A2A" />
      <rect
        opacity="0.3"
        x="13"
        y="4"
        width="16"
        height="2"
        rx="1"
        transform="rotate(90 13 4)"
        fill={props?.fill ?? "#2A2A2A"}
      />
    </svg>
  );
};

export const WidgetEmptyIcon = (props: any) => {
  return (
    <svg
      width="56"
      height="72"
      viewBox="0 0 56 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27.9998" cy="27.9656" r="27.9656" fill="#F1F1F1" />
      <rect
        x="17.029"
        y="27.3956"
        width="27.379"
        height="38.3305"
        rx="2.7379"
        transform="rotate(2.5 17.029 27.3956)"
        fill="#EEEEEE"
        stroke="#999999"
        stroke-width="0.782256"
      />
      <rect
        x="0.751596"
        y="25.1027"
        width="28.9435"
        height="39.895"
        rx="3.52015"
        transform="rotate(-7.5 0.751596 25.1027)"
        fill="#FAFAFA"
        stroke="#999999"
        stroke-width="0.782256"
      />
      <path
        d="M1.59885 28.5417C1.37329 26.8284 2.57936 25.2566 4.29268 25.031L26.0085 22.1721C27.7218 21.9465 29.2936 23.1526 29.5191 24.8659L30.2849 30.6827L2.36464 34.3584L1.59885 28.5417Z"
        fill="#EEEEEE"
      />
      <rect
        x="35.1836"
        y="22.9369"
        width="1.17338"
        height="3.91128"
        rx="0.586692"
        transform="rotate(82.5 35.1836 22.9369)"
        fill="#999999"
      />
      <rect
        x="24.4678"
        y="16.4575"
        width="1.17338"
        height="3.91128"
        rx="0.586692"
        transform="rotate(-7.5 24.4678 16.4575)"
        fill="#999999"
      />
      <rect
        x="31.3428"
        y="17.525"
        width="1.17338"
        height="3.91128"
        rx="0.586692"
        transform="rotate(37.5 31.3428 17.525)"
        fill="#999999"
      />
      <rect
        x="5.28418"
        y="35.5522"
        width="22.6854"
        height="1.56451"
        rx="0.782256"
        transform="rotate(-7.5 5.28418 35.5522)"
        fill="#DCDCDC"
      />
      <rect
        x="6.30566"
        y="43.308"
        width="22.6854"
        height="1.56451"
        rx="0.782256"
        transform="rotate(-7.5 6.30566 43.308)"
        fill="#DCDCDC"
      />
      <rect
        x="7.32617"
        y="51.0636"
        width="22.6854"
        height="1.56451"
        rx="0.782256"
        transform="rotate(-7.5 7.32617 51.0636)"
        fill="#DCDCDC"
      />
      <rect
        x="5.69238"
        y="38.6545"
        width="8.21369"
        height="1.56451"
        rx="0.782256"
        transform="rotate(-7.5 5.69238 38.6545)"
        fill="#EEEEEE"
      />
      <rect
        x="6.71387"
        y="46.4102"
        width="8.21369"
        height="1.56451"
        rx="0.782256"
        transform="rotate(-7.5 6.71387 46.4102)"
        fill="#EEEEEE"
      />
      <rect
        x="7.73438"
        y="54.1658"
        width="8.21369"
        height="1.56451"
        rx="0.782256"
        transform="rotate(-7.5 7.73438 54.1658)"
        fill="#EEEEEE"
      />
    </svg>
  );
};

export const ThemeingIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C6.49 22 2 17.51 2 12C2 6.49 6.49 2 12 2C17.51 2 22 6.04 22 11C22 14.31 19.31 17 16 17H14.23C13.95 17 13.73 17.22 13.73 17.5C13.73 17.62 13.78 17.73 13.86 17.83C14.27 18.3 14.5 18.89 14.5 19.5C14.5 20.88 13.38 22 12 22ZM12 4C7.59 4 4 7.59 4 12C4 16.41 7.59 20 12 20C12.28 20 12.5 19.78 12.5 19.5C12.5 19.34 12.42 19.22 12.36 19.15C11.95 18.69 11.73 18.1 11.73 17.5C11.73 16.12 12.85 15 14.23 15H16C18.21 15 20 13.21 20 11C20 7.14 16.41 4 12 4Z"
        fill="#53C06A"
      />
      <path
        d="M6.5 13C7.32843 13 8 12.3284 8 11.5C8 10.6716 7.32843 10 6.5 10C5.67157 10 5 10.6716 5 11.5C5 12.3284 5.67157 13 6.5 13Z"
        fill="#53C06A"
      />
      <path
        d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z"
        fill="#53C06A"
      />
      <path
        d="M14.5 9C15.3284 9 16 8.32843 16 7.5C16 6.67157 15.3284 6 14.5 6C13.6716 6 13 6.67157 13 7.5C13 8.32843 13.6716 9 14.5 9Z"
        fill="#53C06A"
      />
      <path
        d="M17.5 13C18.3284 13 19 12.3284 19 11.5C19 10.6716 18.3284 10 17.5 10C16.6716 10 16 10.6716 16 11.5C16 12.3284 16.6716 13 17.5 13Z"
        fill="#53C06A"
      />
    </svg>
  );
};

export const LogoutIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00098 11.999L16.001 11.999M16.001 11.999L12.501 8.99902M16.001 11.999L12.501 14.999"
        stroke={props?.stroke ?? "#1C274C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.5"
        d="M9.00195 7C9.01406 4.82497 9.11051 3.64706 9.87889 2.87868C10.7576 2 12.1718 2 15.0002 2L16.0002 2C18.8286 2 20.2429 2 21.1215 2.87868C22.0002 3.75736 22.0002 5.17157 22.0002 8L22.0002 16C22.0002 18.8284 22.0002 20.2426 21.1215 21.1213C20.2429 22 18.8286 22 16.0002 22H15.0002C12.1718 22 10.7576 22 9.87889 21.1213C9.11051 20.3529 9.01406 19.175 9.00195 17"
        stroke={props?.stroke ?? "#1C274C"}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const JollofPlate = (props: any) => {
  return (
    <svg
      width="25"
      height="23"
      viewBox="0 0 25 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.49483 13.4923L3.04993 11.2274L3.44587 9.66986L6.7879 7.46123L11.4041 6.89453L16.6432 7.57382L19.1652 8.56461C19.1652 8.56461 21.0624 10.2065 21.0905 10.5462C21.1187 10.8858 20.5801 12.6704 20.552 12.7548C20.5238 12.8393 20.156 14.6801 19.0508 15.076C17.9455 15.472 10.8392 16.4928 10.7248 16.4346C10.6103 16.3764 4.49483 13.4923 4.49483 13.4923Z"
        fill="#2F2F2F"
      />
      <path
        d="M3.73114 12.7846C3.73114 12.7846 3.7743 12.3042 3.93755 11.8257C4.15523 11.184 6.16683 8.39551 11.8019 8.39551C17.437 8.39551 20.552 11.1708 20.2405 12.5576C19.929 13.9443 16.0503 17.4289 16.0503 17.4289C16.0503 17.4289 9.25366 16.3819 9.14107 16.3537C9.0266 16.3237 3.73114 12.7846 3.73114 12.7846Z"
        fill="#F7B03A"
      />
      <path
        d="M6.35248 11.1332C6.18735 11.1689 6.04286 11.2758 6.05787 11.4672C6.071 11.6587 6.24739 11.7487 6.40502 11.7225C6.65084 11.6812 6.73904 11.5067 6.70713 11.3359C6.67523 11.1801 6.5026 11.0995 6.35248 11.1332ZM6.19485 12.0246C6.35998 12.2854 6.11041 12.6476 5.61126 12.8052C5.11212 12.9628 4.76497 12.884 4.70679 12.5425C4.64862 12.201 5.09335 11.9852 5.32228 11.9063C5.55122 11.8275 6.02409 11.7562 6.19485 12.0246ZM8.86885 10.1368C8.88011 10.3901 9.24228 10.5309 9.75456 10.4652C10.2668 10.3995 10.5408 10.1181 10.5145 9.86285C10.4883 9.60765 10.128 9.50819 9.71515 9.53446C9.30232 9.56073 8.85572 9.81594 8.86885 10.1368ZM10.6271 9.47442C10.6271 9.70147 10.8955 9.77653 11.2426 9.75589C11.6554 9.73337 11.768 9.57199 11.7868 9.42187C11.8056 9.27175 11.5579 9.03532 11.2088 9.06159C10.8636 9.08786 10.6271 9.22484 10.6271 9.47442ZM14.0686 11.5986C14.0423 11.8857 14.2394 12.201 15.0125 12.1372C15.7856 12.0734 15.9376 11.6849 15.9376 11.5479C15.9376 11.411 15.81 10.9944 15.0725 10.9831C14.6278 10.9756 14.108 11.1651 14.0686 11.5986ZM17.6696 11.4353C17.6546 11.5817 17.7015 11.9608 18.3977 11.9401C19.092 11.9214 19.0075 11.6849 19.0075 11.5798C19.0075 11.4748 18.7711 11.0882 18.2795 11.0357C17.8873 10.9925 17.6959 11.1914 17.6696 11.4353ZM18.5609 12.4505C18.5478 12.6269 18.7505 12.7658 19.1839 12.7395C19.5517 12.717 19.7112 12.5237 19.7018 12.3792C19.6887 12.1691 19.486 12.064 19.1708 12.0771C18.895 12.0884 18.5816 12.2028 18.5609 12.4505ZM10.6009 14.2088C10.6084 14.3589 10.9292 14.5372 11.4472 14.5372C11.9651 14.5372 12.0626 14.3214 12.0626 14.1638C12.0626 14.0061 11.8994 13.8298 11.4209 13.8091C10.993 13.7903 10.5877 13.9536 10.6009 14.2088Z"
        fill="#FFE36A"
      />
      <path
        d="M5.22498 13.6905C5.24374 13.6455 5.26626 13.4485 5.36196 13.2833C5.4464 13.1389 5.59652 13.0206 5.76916 13.0206C6.07127 13.0206 6.75244 13.1389 6.91007 13.3547C7.02453 13.5123 7.01515 14.0959 6.55541 14.246C6.09567 14.398 5.22498 13.6905 5.22498 13.6905ZM6.62672 10.6731C6.6361 10.7932 6.82938 11.0334 7.08646 11.0147C7.34166 10.9959 8.08287 10.6544 8.15606 10.5024C8.22736 10.3523 7.92712 10.0107 7.73009 10.0107C7.53306 10.0107 6.60795 10.4254 6.62672 10.6731ZM14.1815 12.6941C14.1045 12.8499 14.0238 13.3096 14.3579 13.4353C14.6919 13.5592 15.9848 13.6192 15.9848 13.2458C15.9848 12.8724 15.617 12.6041 15.48 12.5834C15.3411 12.5628 14.2997 12.4577 14.1815 12.6941ZM15.6958 12.0843C15.4838 12.4127 15.8703 12.803 16.1555 12.9362C16.771 13.2252 17.0807 13.1764 17.2965 13.015C17.6642 12.7392 17.5385 12.4633 16.7523 12.0974C16.1912 11.8347 15.8403 11.861 15.6958 12.0843Z"
        fill="#D64C12"
      />
      <path
        d="M12.2354 10.1278C12.2298 10.4749 13.0067 10.8258 13.5659 10.8427C14.1251 10.8596 14.2714 10.5969 14.3127 10.4731C14.354 10.3492 14.157 9.92325 13.9355 9.74123C13.7141 9.55921 13.1474 9.37156 12.8922 9.40534C12.637 9.43724 12.2429 9.68494 12.2354 10.1278Z"
        fill="#7F594B"
      />
      <path
        d="M7.66795 11.9509C7.70548 12.1855 8.06389 12.345 8.6944 12.3862C9.45813 12.435 9.94226 12.0898 9.95915 11.9434C9.97604 11.7952 9.53131 11.418 8.75257 11.418C7.80681 11.4161 7.63605 11.7445 7.66795 11.9509Z"
        fill="#FE8D00"
      />
      <path
        d="M7.39753 13.3473C7.37313 13.7657 7.66774 13.9384 8.07869 13.9215C8.48965 13.9046 9.26089 13.5199 9.41663 13.0752C9.51421 12.7993 9.05447 12.3114 8.38081 12.3358C7.99238 12.3509 7.41817 12.9814 7.39753 13.3473Z"
        fill="#7F594B"
      />
      <path
        d="M14.626 10.8745C14.7911 10.9646 15.4066 10.792 15.8908 10.6944C16.3749 10.5968 16.8684 10.5462 16.9416 10.3904C17.0148 10.2347 16.8834 9.57788 16.161 9.51971C15.4385 9.46154 15.0276 9.73363 14.8549 9.92128C14.6823 10.1108 14.5678 10.3397 14.5585 10.4054C14.5509 10.473 14.5115 10.8126 14.626 10.8745ZM17.5665 12.1074C17.801 12.0661 17.649 11.3606 17.4595 11.1466C17.27 10.9327 16.7371 10.8351 16.3993 10.8764C16.0634 10.9177 15.8326 11.0078 15.8157 11.1973C15.7988 11.3868 16.3993 11.7058 16.7108 11.8466C17.0242 11.9835 17.4257 12.1318 17.5665 12.1074Z"
        fill="#FE8D00"
      />
      <path
        d="M9.50154 12.6389C9.69482 12.7064 10.1452 12.5751 10.1508 12.2899C10.1564 12.0046 9.89936 11.7382 9.64603 11.7963C9.51843 11.8245 9.25197 12.1566 9.2576 12.2842C9.26322 12.4137 9.40208 12.6051 9.50154 12.6389ZM10.4473 10.9275C10.4642 11.1546 10.969 11.391 11.1435 11.2409C11.3086 11.0983 11.2129 10.4922 10.999 10.4922C10.7325 10.4922 10.4398 10.8337 10.4473 10.9275ZM10.9239 12.0178C10.9277 12.0985 11.0459 12.47 11.3367 12.4644C11.6276 12.4588 12.0217 12.1623 12.0217 12.0121C12.0217 11.862 11.5638 11.3798 11.348 11.3854C11.2016 11.3892 10.9183 11.862 10.9239 12.0178Z"
        fill="#92A51E"
      />
      <path
        d="M11.8806 10.9445C11.8468 11.1453 11.997 11.1659 12.1302 11.1884C12.2634 11.211 12.4323 11.2523 12.6068 11.4793C12.7813 11.7064 12.9521 12.1774 12.9727 12.228C13.0365 12.3913 13.3274 12.4776 13.5357 12.2749C13.744 12.0723 13.333 11.1791 12.9671 10.8938C12.5993 10.6086 11.9444 10.573 11.8806 10.9445Z"
        fill="#FBE0BC"
      />
      <path
        d="M11.7871 11.4202C11.8152 11.606 12.2393 11.9475 12.5358 11.7974C12.8323 11.6473 12.5133 11.0937 12.3838 11.0337C12.3031 10.9942 11.7458 11.15 11.7871 11.4202ZM13.5116 10.9623C13.3784 10.9567 13.2676 11.0036 13.2733 11.2288C13.2789 11.4559 13.3652 11.7111 13.6617 11.728C13.9582 11.7448 13.9863 11.3564 13.9863 11.3095C13.9863 11.2626 13.8062 10.9736 13.5116 10.9623ZM13.5979 12.1915C13.4872 12.1652 12.9543 12.3941 12.943 12.6099C12.9318 12.8238 13.1288 12.9871 13.4647 13.0284C13.8006 13.0696 14.0276 13.0696 14.0745 12.9064C14.1196 12.7431 13.9282 12.2721 13.5979 12.1915Z"
        fill="#92A51E"
      />
      <path
        d="M16.0164 14.1453C16.037 14.271 16.4799 14.468 16.6225 14.4286C16.7632 14.3892 17.1104 13.6649 17.6302 13.5166C18.15 13.3665 18.3226 13.4303 18.3939 13.3515C18.4652 13.2727 18.362 12.9105 18.1894 12.8486C18.0167 12.7867 17.5514 12.6985 16.9697 13.0381C16.3729 13.3834 15.992 14.0045 16.0164 14.1453ZM10.4714 12.3588C10.2162 12.3739 9.87276 12.7529 9.72452 13.0982C9.49747 13.6217 9.42616 14.0571 9.48808 14.1678C9.55188 14.2785 10.0041 14.4324 10.188 14.3085C10.2349 14.2766 10.2818 13.6949 10.5108 13.2539C10.6665 12.9556 10.9274 12.8373 10.9743 12.7904C11.0212 12.7435 10.8879 12.3363 10.4714 12.3588ZM8.27587 9.70173C8.20644 9.76741 8.01691 10.0714 8.07884 10.6062C8.12763 11.0134 8.18392 11.2611 8.31528 11.3211C8.41661 11.3681 9.14093 11.4394 9.20473 11.2498C9.26853 11.0603 8.82005 10.5349 8.77126 10.4392C8.72247 10.3435 8.69996 9.79368 8.69245 9.72425C8.68494 9.65294 8.38658 9.59852 8.27587 9.70173Z"
        fill="#FBE0AF"
      />
      <path
        d="M23.044 9.64118C22.7044 8.96189 22.3366 8.70669 22.0251 8.70669C21.7136 8.70669 20.6383 9.21709 20.6383 9.21709C20.6383 9.21709 18.2271 6.62753 12.1116 6.53934C6.19311 6.45302 3.67674 8.90184 3.67674 8.90184C3.67674 8.90184 2.82481 8.25258 2.00291 8.33702C1.18288 8.42334 0.475443 10.5757 0.843236 11.1987C1.21103 11.8217 1.74958 11.7935 2.17367 12.0206C2.59776 12.2476 2.99557 12.5028 3.08001 12.6436C3.16446 12.7843 3.41966 15.9293 4.21342 17.3442C5.00717 18.7609 6.50649 20.6581 12.0009 20.7707C17.4952 20.8832 18.9777 18.6652 19.6457 17.4005C20.4394 15.8993 20.8072 13.1239 20.8072 13.1239C20.8072 13.1239 21.3739 12.6135 21.9969 12.3602C22.6856 12.0787 22.9877 12.0206 23.1866 11.7372C23.3837 11.452 23.3837 10.3205 23.044 9.64118ZM12.1979 14.9366C6.27943 14.8785 3.41778 13.0095 3.5041 10.8872C3.5604 9.50044 6.33573 7.20549 11.7738 7.26179C17.27 7.31996 20.6946 9.30153 20.6665 11.1405C20.6365 12.9813 18.0038 14.9929 12.1979 14.9366Z"
        fill="#6A6E70"
      />
      <path
        opacity="0.6"
        d="M11.9804 9.7624C12.579 9.6986 12.3069 8.69093 12.7985 7.7189C13.9225 5.49151 16.1312 5.26633 16.0692 3.36544C16.0017 1.28629 12.7779 0.276735 11.7965 1.07424C11.4812 1.33132 13.2883 1.62593 13.0031 2.81188C12.7159 3.99782 10.5298 4.07851 9.99879 5.97939C9.36641 8.23494 11.5919 9.80181 11.9804 9.7624Z"
        fill="#EAEAEA"
      />
    </svg>
  );
};

export const MinusIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4.03821"
        y="11.0898"
        width="16.0127"
        height="2.00159"
        rx="1.0008"
        fill={props?.fill ?? "#2A2A2A"}
      />
    </svg>
  );
};

export const IGIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.19967 1.33325H10.7997C12.933 1.33325 14.6663 3.06659 14.6663 5.19992V10.7999C14.6663 11.8254 14.259 12.8089 13.5338 13.5341C12.8087 14.2592 11.8252 14.6666 10.7997 14.6666H5.19967C3.06634 14.6666 1.33301 12.9333 1.33301 10.7999V5.19992C1.33301 4.17442 1.74039 3.19091 2.46553 2.46577C3.19067 1.74063 4.17417 1.33325 5.19967 1.33325ZM5.06634 2.66659C4.42982 2.66659 3.81937 2.91944 3.36929 3.36953C2.9192 3.81962 2.66634 4.43007 2.66634 5.06659V10.9333C2.66634 12.2599 3.73967 13.3333 5.06634 13.3333H10.933C11.5695 13.3333 12.18 13.0804 12.6301 12.6303C13.0802 12.1802 13.333 11.5698 13.333 10.9333V5.06659C13.333 3.73992 12.2597 2.66659 10.933 2.66659H5.06634ZM11.4997 3.66659C11.7207 3.66659 11.9327 3.75438 12.0889 3.91066C12.2452 4.06694 12.333 4.2789 12.333 4.49992C12.333 4.72093 12.2452 4.93289 12.0889 5.08917C11.9327 5.24545 11.7207 5.33325 11.4997 5.33325C11.2787 5.33325 11.0667 5.24545 10.9104 5.08917C10.7541 4.93289 10.6663 4.72093 10.6663 4.49992C10.6663 4.2789 10.7541 4.06694 10.9104 3.91066C11.0667 3.75438 11.2787 3.66659 11.4997 3.66659ZM7.99967 4.66659C8.88373 4.66659 9.73158 5.01777 10.3567 5.6429C10.9818 6.26802 11.333 7.11586 11.333 7.99992C11.333 8.88397 10.9818 9.73182 10.3567 10.3569C9.73158 10.9821 8.88373 11.3333 7.99967 11.3333C7.11562 11.3333 6.26777 10.9821 5.64265 10.3569C5.01753 9.73182 4.66634 8.88397 4.66634 7.99992C4.66634 7.11586 5.01753 6.26802 5.64265 5.6429C6.26777 5.01777 7.11562 4.66659 7.99967 4.66659ZM7.99967 5.99992C7.46924 5.99992 6.96053 6.21063 6.58546 6.5857C6.21039 6.96078 5.99967 7.46949 5.99967 7.99992C5.99967 8.53035 6.21039 9.03906 6.58546 9.41413C6.96053 9.78921 7.46924 9.99992 7.99967 9.99992C8.53011 9.99992 9.03882 9.78921 9.41389 9.41413C9.78896 9.03906 9.99967 8.53035 9.99967 7.99992C9.99967 7.46949 9.78896 6.96078 9.41389 6.5857C9.03882 6.21063 8.53011 5.99992 7.99967 5.99992Z"
        fill={props?.fill ?? "white"}
      />
    </svg>
  );
};

export const TwitterIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6995 1.88109C14.1491 2.12492 13.5653 2.28497 12.9675 2.35592C13.5902 1.98272 14.0683 1.39173 14.2934 0.687577C13.7015 1.03884 13.0539 1.28633 12.3785 1.41935C11.8284 0.833299 11.0448 0.467041 10.1774 0.467041C8.51196 0.467041 7.1617 1.81724 7.1617 3.48254C7.1617 3.71893 7.1884 3.94905 7.23979 4.16982C4.73357 4.04402 2.51156 2.8435 1.02419 1.01904C0.76467 1.46442 0.615962 1.98249 0.615962 2.53506C0.615962 3.5813 1.14838 4.50427 1.95749 5.04507C1.47861 5.03007 1.01027 4.90073 0.59156 4.66784C0.591388 4.68048 0.591388 4.69311 0.591388 4.7058C0.591388 6.16687 1.63085 7.3857 3.01034 7.66273C2.56627 7.7835 2.10048 7.80118 1.64854 7.71441C2.03225 8.91246 3.14595 9.78427 4.46549 9.80867C3.43344 10.6174 2.13313 11.0996 0.720345 11.0996C0.4769 11.0996 0.2369 11.0853 0.000976562 11.0574C1.3355 11.913 2.92059 12.4123 4.62356 12.4123C10.1704 12.4123 13.2035 7.81718 13.2035 3.83227C13.2035 3.70147 13.2006 3.57142 13.1948 3.44212C13.7851 3.01534 14.2947 2.48672 14.6995 1.88109Z"
        fill={props?.fill ?? "white"}
      />
    </svg>
  );
};

export const TikTokIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16142 5.54101C10.0631 6.18525 11.1678 6.56431 12.3608 6.56431V4.26976C12.135 4.26981 11.9098 4.24625 11.6889 4.19947V6.00561C10.496 6.00561 9.39146 5.6266 8.48957 4.98241V9.66497C8.48957 12.0075 6.58962 13.9062 4.24612 13.9062C3.3717 13.9062 2.55893 13.642 1.88379 13.1889C2.65437 13.9764 3.72899 14.4649 4.91783 14.4649C7.26153 14.4649 9.16152 12.5661 9.16152 10.2235V5.54101H9.16142ZM9.99032 3.22608C9.52948 2.7229 9.22689 2.07263 9.16142 1.3537V1.05859H8.52471C8.68499 1.97231 9.23171 2.75293 9.99032 3.22608ZM3.36605 11.3914C3.10859 11.054 2.96942 10.6412 2.97004 10.2168C2.97004 9.14548 3.83906 8.2768 4.91122 8.2768C5.11099 8.2767 5.30959 8.30736 5.50004 8.3677V6.02183C5.27749 5.99137 5.05291 5.97839 4.82842 5.98317V7.80906C4.63789 7.74867 4.43919 7.71802 4.23931 7.7182C3.1672 7.7182 2.29824 8.58678 2.29824 9.65826C2.29824 10.4159 2.73257 11.0718 3.36605 11.3914Z"
        fill={props?.fill ?? "#FF004F"}
      />
      <path
        d="M8.48999 4.98236C9.39193 5.62655 10.4963 6.00557 11.6893 6.00557V4.19942C11.0234 4.05764 10.4339 3.70986 9.99069 3.22608C9.23204 2.75288 8.68541 1.97226 8.52514 1.05859H6.85272V10.2234C6.8489 11.2919 5.98138 12.157 4.91154 12.157C4.28116 12.157 3.72106 11.8566 3.36638 11.3913C2.733 11.0718 2.29861 10.4159 2.29861 9.65831C2.29861 8.58692 3.16758 7.71825 4.23969 7.71825C4.4451 7.71825 4.64308 7.75021 4.8288 7.8091V5.98321C2.52643 6.03077 0.674805 7.91101 0.674805 10.2235C0.674805 11.3778 1.13589 12.4243 1.88426 13.189C2.5594 13.642 3.37212 13.9063 4.24659 13.9063C6.59014 13.9063 8.49004 12.0074 8.49004 9.66497V4.98241L8.48999 4.98236Z"
        fill={props?.fill ?? "white"}
      />
      <path
        d="M11.6893 4.19938V3.71112C11.0888 3.71203 10.5002 3.54395 9.99067 3.22609C10.4417 3.71957 11.0355 4.05988 11.6893 4.19948V4.19938ZM8.52507 1.05855C8.50979 0.97125 8.49807 0.883364 8.48992 0.79511V0.5H6.1807V9.66493C6.17703 10.7333 5.30951 11.5984 4.23962 11.5984C3.93631 11.5988 3.63716 11.5279 3.36631 11.3914C3.72099 11.8567 4.28109 12.1569 4.91147 12.1569C5.98127 12.1569 6.84888 11.2919 6.85265 10.2235V1.0586H8.52507V1.05855ZM4.82887 5.98317V5.46329C4.63591 5.43691 4.44138 5.42372 4.24662 5.4238C1.90283 5.4238 0.00292969 7.32268 0.00292969 9.66493C0.00292969 11.1334 0.749613 12.4276 1.88429 13.1889C1.13592 12.4243 0.674833 11.3778 0.674833 10.2234C0.674833 7.91102 2.52641 6.03072 4.82887 5.98317Z"
        fill={props?.fill ?? "#00F2EA"}
      />
    </svg>
  );
};

export const SnapChatIcon = (props: any) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2921 17.5564C24.124 17.0957 23.8003 16.8467 23.4329 16.6475C23.3645 16.6101 23.3022 16.5728 23.2462 16.5479C23.1341 16.4918 23.022 16.4358 22.91 16.3798C21.7645 15.7697 20.868 15.0101 20.2516 14.1012C20.0773 13.8459 19.9217 13.572 19.7971 13.2918C19.7411 13.1424 19.7473 13.0553 19.7847 12.9743C19.822 12.9121 19.8718 12.8623 19.9341 12.8187C20.1333 12.6879 20.3325 12.5572 20.4695 12.47C20.7123 12.3082 20.9115 12.1837 21.036 12.0965C21.503 11.7665 21.8329 11.4179 22.0384 11.0257C22.331 10.4778 22.3683 9.83658 22.1442 9.25759C21.8329 8.4358 21.061 7.93152 20.1209 7.93152C19.9217 7.93152 19.7287 7.95019 19.5294 7.99377C19.4796 8.00623 19.4236 8.01868 19.3738 8.03113C19.38 7.47082 19.3676 6.87938 19.3178 6.29416C19.1434 4.24591 18.4213 3.1751 17.6742 2.32218C17.1948 1.78677 16.6345 1.3323 16.0057 0.977432C14.8726 0.329961 13.5839 0 12.1831 0C10.7824 0 9.49986 0.329961 8.36679 0.977432C7.73799 1.3323 7.17768 1.78677 6.69831 2.32218C5.95122 3.1751 5.23527 4.25214 5.05473 6.29416C5.00492 6.87938 4.99247 7.47082 4.99869 8.03113C4.94889 8.01868 4.89908 8.00623 4.84305 7.99377C4.65006 7.95019 4.45084 7.93152 4.25784 7.93152C3.31776 7.93152 2.54578 8.44202 2.23449 9.25759C2.01037 9.83658 2.04772 10.4778 2.34033 11.0257C2.54578 11.4179 2.87574 11.7665 3.34266 12.0965C3.46718 12.1837 3.66017 12.3082 3.9092 12.47C4.03994 12.5572 4.23294 12.6817 4.42593 12.8062C4.49441 12.8498 4.55045 12.9058 4.59403 12.9743C4.63138 13.0553 4.63761 13.1424 4.57535 13.3043C4.45084 13.5782 4.30142 13.8459 4.1271 14.0949C3.52321 14.979 2.65161 15.7323 1.54344 16.3362C0.958229 16.6475 0.348112 16.8529 0.0866331 17.5564C-0.106363 18.0856 0.0181506 18.6833 0.509979 19.1938C0.690524 19.3805 0.902197 19.5424 1.13255 19.6669C1.61193 19.9284 2.12243 20.1339 2.65784 20.277C2.7699 20.3082 2.86951 20.3518 2.9629 20.414C3.14344 20.5697 3.11854 20.8062 3.35512 21.1549C3.4734 21.3354 3.62905 21.4911 3.80336 21.6156C4.30764 21.9642 4.87418 21.9829 5.47185 22.0078C6.01348 22.0265 6.6236 22.0514 7.3271 22.2817C7.61971 22.3751 7.91854 22.5619 8.26718 22.7798C9.10764 23.2965 10.2532 24 12.1769 24C14.1006 24 15.2524 23.2903 16.0991 22.7735C16.4477 22.5619 16.7466 22.3751 17.0267 22.2817C17.724 22.0514 18.3403 22.0265 18.882 22.0078C19.4796 21.9829 20.0462 21.9642 20.5504 21.6156C20.7621 21.4661 20.9364 21.2794 21.061 21.0553C21.2353 20.7626 21.229 20.5572 21.3909 20.414C21.4781 20.3518 21.5777 20.3082 21.6773 20.2833C22.2127 20.1401 22.7357 19.9346 23.2213 19.6669C23.4641 19.5362 23.6882 19.3619 23.875 19.1564L23.8812 19.1502C24.3668 18.6521 24.4851 18.0669 24.2921 17.5564ZM22.5862 18.4716C21.5466 19.0444 20.8493 18.9821 20.3139 19.3307C19.8532 19.6233 20.1271 20.2584 19.7971 20.4887C19.3862 20.7689 18.1785 20.47 16.622 20.9868C15.3333 21.4101 14.5178 22.6366 12.2018 22.6366C9.88585 22.6366 9.08897 21.4163 7.78157 20.9868C6.22515 20.47 5.01737 20.7751 4.60648 20.4887C4.27652 20.2584 4.54422 19.6233 4.08975 19.3307C3.54811 18.9821 2.85706 19.0444 1.81737 18.4716C1.15122 18.1043 1.53099 17.8802 1.74889 17.7743C5.52165 15.9502 6.12554 13.13 6.15045 12.9183C6.18157 12.663 6.21893 12.4638 5.93877 12.2086C5.67107 11.9595 4.47574 11.2187 4.13955 10.9883C3.59169 10.6023 3.34889 10.2226 3.52943 9.74942C3.65395 9.42568 3.95901 9.30117 4.27652 9.30117C4.37613 9.30117 4.47574 9.31362 4.57535 9.3323C5.17924 9.46303 5.76445 9.76187 6.10064 9.84903C6.14422 9.86148 6.18157 9.8677 6.22515 9.8677C6.4057 9.8677 6.46796 9.77432 6.4555 9.56887C6.41815 8.90895 6.32476 7.62646 6.4306 6.4249C6.57379 4.7751 7.10297 3.95331 7.73799 3.23113C8.04305 2.88249 9.46873 1.37588 12.2018 1.37588C14.9349 1.37588 16.3606 2.87626 16.6656 3.2249C17.3006 3.94708 17.8298 4.76887 17.973 6.41868C18.0789 7.62023 17.9855 8.90272 17.9419 9.56265C17.9294 9.78054 17.9917 9.86148 18.1722 9.86148C18.2158 9.86148 18.2532 9.85525 18.2967 9.8428C18.6329 9.76187 19.2182 9.45681 19.822 9.32607C19.9217 9.30117 20.0213 9.29494 20.1209 9.29494C20.4384 9.29494 20.7434 9.41946 20.868 9.74319C21.0485 10.2163 20.8057 10.5961 20.2578 10.9821C19.9279 11.2125 18.7325 11.9533 18.4586 12.2023C18.1785 12.4576 18.2158 12.6568 18.2469 12.9121C18.2718 13.1237 18.8757 15.944 22.6485 17.7681C22.8726 17.8739 23.2462 18.1043 22.5862 18.4716Z"
        fill={props?.fill ?? "white"}
      />
    </svg>
  );
};

export const LinkedinIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19ZM18.5 18.5V13.2C18.5 12.3354 18.1565 11.5062 17.5452 10.8948C16.9338 10.2835 16.1046 9.94 15.24 9.94C14.39 9.94 13.4 10.46 12.92 11.24V10.13H10.13V18.5H12.92V13.57C12.92 12.8 13.54 12.17 14.31 12.17C14.6813 12.17 15.0374 12.3175 15.2999 12.5801C15.5625 12.8426 15.71 13.1987 15.71 13.57V18.5H18.5ZM6.88 8.56C7.32556 8.56 7.75288 8.383 8.06794 8.06794C8.383 7.75288 8.56 7.32556 8.56 6.88C8.56 5.95 7.81 5.19 6.88 5.19C6.43178 5.19 6.00193 5.36805 5.68499 5.68499C5.36805 6.00193 5.19 6.43178 5.19 6.88C5.19 7.81 5.95 8.56 6.88 8.56ZM8.27 18.5V10.13H5.5V18.5H8.27Z"
        fill="white"
      />
    </svg>
  );
};

export const YoutubeIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15L15.19 12L10 9V15ZM21.56 7.17C21.69 7.64 21.78 8.27 21.84 9.07C21.91 9.87 21.94 10.56 21.94 11.16L22 12C22 14.19 21.84 15.8 21.56 16.83C21.31 17.73 20.73 18.31 19.83 18.56C19.36 18.69 18.5 18.78 17.18 18.84C15.88 18.91 14.69 18.94 13.59 18.94L12 19C7.81 19 5.2 18.84 4.17 18.56C3.27 18.31 2.69 17.73 2.44 16.83C2.31 16.36 2.22 15.73 2.16 14.93C2.09 14.13 2.06 13.44 2.06 12.84L2 12C2 9.81 2.16 8.2 2.44 7.17C2.69 6.27 3.27 5.69 4.17 5.44C4.64 5.31 5.5 5.22 6.82 5.16C8.12 5.09 9.31 5.06 10.41 5.06L12 5C16.19 5 18.8 5.16 19.83 5.44C20.73 5.69 21.31 6.27 21.56 7.17Z"
        fill="white"
      />
    </svg>
  );
};

export const BlackYoutubeIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? "48"}
      height={props?.height ?? "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM34.0016 15.7493C35.1031 16.0516 35.9706 16.9422 36.265 18.0732C36.8 20.123 36.8 24.4 36.8 24.4C36.8 24.4 36.8 28.6768 36.265 30.7268C35.9706 31.8578 35.1031 32.7484 34.0016 33.0508C32.0054 33.6 24 33.6 24 33.6C24 33.6 15.9946 33.6 13.9983 33.0508C12.8967 32.7484 12.0292 31.8578 11.7348 30.7268C11.2 28.6768 11.2 24.4 11.2 24.4C11.2 24.4 11.2 20.123 11.7348 18.0732C12.0292 16.9422 12.8967 16.0516 13.9983 15.7493C15.9946 15.2 24 15.2 24 15.2C24 15.2 32.0054 15.2 34.0016 15.7493Z"
        fill="black"
      />
      <path d="M21.6 28.8V20.8L28 24.8001L21.6 28.8Z" fill="black" />
    </svg>
  );
};

export const BlackLinkedInIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? "48"}
      height={props?.height ?? "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM11.5216 19.8778H16.9605V36.2196H11.5216V19.8778ZM17.3188 14.8227C17.2835 13.2204 16.1377 12 14.277 12C12.4164 12 11.2 13.2204 11.2 14.8227C11.2 16.3918 12.3805 17.6473 14.2064 17.6473H14.2412C16.1377 17.6473 17.3188 16.3918 17.3188 14.8227ZM30.3131 19.4941C33.8922 19.4941 36.5754 21.8303 36.5754 26.8497L36.5752 36.2196H31.1365V27.4767C31.1365 25.2807 30.3494 23.7822 28.3805 23.7822C26.8779 23.7822 25.9829 24.7924 25.5898 25.7682C25.446 26.1178 25.4107 26.605 25.4107 27.0934V36.22H19.9711C19.9711 36.22 20.0428 21.4117 19.9711 19.8783H25.4107V22.1929C26.1325 21.0802 27.4254 19.4941 30.3131 19.4941Z"
        fill="black"
      />
    </svg>
  );
};

export const BlackInstagramIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? "48"}
      height={props?.height ?? "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM18.7233 11.2773C20.0886 11.2152 20.5249 11.2 24.0012 11.2H23.9972C27.4746 11.2 27.9092 11.2152 29.2746 11.2773C30.6373 11.3397 31.5679 11.5555 32.384 11.872C33.2266 12.1987 33.9386 12.636 34.6506 13.348C35.3627 14.0595 35.8 14.7736 36.128 15.6155C36.4427 16.4294 36.6587 17.3595 36.7227 18.7222C36.784 20.0876 36.8 20.5238 36.8 24.0001C36.8 27.4764 36.784 27.9116 36.7227 29.277C36.6587 30.6391 36.4427 31.5695 36.128 32.3837C35.8 33.2253 35.3627 33.9394 34.6506 34.6509C33.9394 35.3629 33.2264 35.8013 32.3848 36.1283C31.5703 36.4448 30.6391 36.6605 29.2765 36.7229C27.9111 36.7851 27.4762 36.8003 23.9996 36.8003C20.5236 36.8003 20.0876 36.7851 18.7222 36.7229C17.3598 36.6605 16.4294 36.4448 15.615 36.1283C14.7736 35.8013 14.0595 35.3629 13.3483 34.6509C12.6365 33.9394 12.1992 33.2253 11.872 32.3834C11.5557 31.5695 11.34 30.6394 11.2773 29.2767C11.2155 27.9114 11.2 27.4764 11.2 24.0001C11.2 20.5238 11.216 20.0873 11.2771 18.7219C11.3384 17.3598 11.5544 16.4294 11.8717 15.6152C12.1997 14.7736 12.6371 14.0595 13.3491 13.348C14.0606 12.6363 14.7747 12.1989 15.6166 11.872C16.4305 11.5555 17.3606 11.3397 18.7233 11.2773Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.853 13.5067C23.0759 13.5064 23.3158 13.5065 23.5746 13.5066L24.0013 13.5067C27.4189 13.5067 27.824 13.519 29.1736 13.5803C30.4216 13.6374 31.0989 13.8459 31.5501 14.0211C32.1475 14.2531 32.5733 14.5305 33.0211 14.9785C33.4691 15.4265 33.7464 15.8532 33.979 16.4505C34.1542 16.9012 34.363 17.5785 34.4198 18.8265C34.4811 20.1759 34.4944 20.5812 34.4944 23.9972C34.4944 27.4133 34.4811 27.8186 34.4198 29.168C34.3627 30.416 34.1542 31.0933 33.979 31.544C33.747 32.1413 33.4691 32.5667 33.0211 33.0144C32.5731 33.4624 32.1477 33.7398 31.5501 33.9718C31.0995 34.1478 30.4216 34.3558 29.1736 34.4128C27.8242 34.4742 27.4189 34.4875 24.0013 34.4875C20.5834 34.4875 20.1783 34.4742 18.8289 34.4128C17.5809 34.3552 16.9036 34.1467 16.4521 33.9715C15.8548 33.7395 15.4281 33.4621 14.9801 33.0141C14.5321 32.5661 14.2548 32.1405 14.0222 31.5429C13.847 31.0923 13.6382 30.4149 13.5814 29.1669C13.5201 27.8176 13.5078 27.4122 13.5078 23.994C13.5078 20.5759 13.5201 20.1727 13.5814 18.8233C13.6385 17.5753 13.847 16.898 14.0222 16.4468C14.2542 15.8494 14.5321 15.4228 14.9801 14.9748C15.4281 14.5268 15.8548 14.2494 16.4521 14.0169C16.9033 13.8409 17.5809 13.6329 18.8289 13.5755C20.0097 13.5222 20.4674 13.5062 22.853 13.5035V13.5067ZM30.8339 15.6321C29.9859 15.6321 29.2978 16.3193 29.2978 17.1676C29.2978 18.0156 29.9859 18.7036 30.8339 18.7036C31.6819 18.7036 32.3699 18.0156 32.3699 17.1676C32.3699 16.3196 31.6819 15.6316 30.8339 15.6316V15.6321ZM17.4279 24.0002C17.4279 20.3701 20.3709 17.4269 24.001 17.4268C27.6312 17.4268 30.5736 20.37 30.5736 24.0002C30.5736 27.6304 27.6314 30.5723 24.0013 30.5723C20.3711 30.5723 17.4279 27.6304 17.4279 24.0002Z"
        fill="black"
      />
      <path
        d="M24.0012 19.7334C26.3575 19.7334 28.2679 21.6436 28.2679 24.0001C28.2679 26.3564 26.3575 28.2668 24.0012 28.2668C21.6447 28.2668 19.7345 26.3564 19.7345 24.0001C19.7345 21.6436 21.6447 19.7334 24.0012 19.7334Z"
        fill="black"
      />
    </svg>
  );
};

export const BlackFacebookIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? "48"}
      height={props?.height ?? "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM26.5016 25.0542V38.1115H21.0991V25.0547H18.4V20.5551H21.0991V17.8536C21.0991 14.1828 22.6231 12 26.9532 12H30.5581V16.5001H28.3048C26.6192 16.5001 26.5077 17.1289 26.5077 18.3025L26.5016 20.5546H30.5836L30.1059 25.0542H26.5016Z"
        fill="black"
      />
    </svg>
  );
};

export const BlackTwitterIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? "48"}
      height={props?.height ?? "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM23.3316 20.338L23.2812 19.5075C23.1301 17.3551 24.4563 15.3891 26.5548 14.6265C27.327 14.3553 28.6364 14.3214 29.4926 14.5587C29.8283 14.6604 30.4663 14.9993 30.9195 15.3044L31.7421 15.8637L32.6486 15.5756C33.1523 15.423 33.8238 15.1688 34.1259 14.9993C34.4113 14.8468 34.6631 14.762 34.6631 14.8129C34.6631 15.101 34.042 16.084 33.5216 16.6263C32.8165 17.389 33.018 17.4568 34.4449 16.9483C35.3011 16.6602 35.3178 16.6602 35.15 16.9822C35.0492 17.1517 34.5288 17.7449 33.9748 18.2872C33.0347 19.2194 32.9844 19.3211 32.9844 20.1007C32.9844 21.304 32.4136 23.8123 31.8428 25.1851C30.7852 27.7612 28.5189 30.422 26.2526 31.7609C23.063 33.6422 18.8157 34.1167 15.24 33.0151C14.0481 32.6422 12 31.6931 12 31.5237C12 31.4728 12.6211 31.405 13.3766 31.3881C14.9546 31.3542 16.5326 30.9135 17.8756 30.1339L18.7822 29.5916L17.7413 29.2357C16.264 28.7272 14.9378 27.5578 14.6021 26.4562C14.5013 26.1003 14.5349 26.0833 15.475 26.0833L16.4487 26.0664L15.6261 25.6766C14.6524 25.1851 13.7627 24.3546 13.3262 23.5072C13.0072 22.8971 12.6044 21.3548 12.7219 21.2362C12.7554 21.1854 13.108 21.287 13.5109 21.4226C14.6692 21.8463 14.8203 21.7446 14.1488 21.0328C12.8897 19.7448 12.5036 17.8296 13.108 16.0162L13.3934 15.2027L14.5013 16.3043C16.7677 18.5245 19.4369 19.8465 22.4922 20.2363L23.3316 20.338Z"
        fill="black"
      />
    </svg>
  );
};

export const SnapchatBlackIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? "48"}
      height={props?.height ?? "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24.245 12H24.2461C24.8152 12 25.9522 12.0797 27.1719 12.6133C27.8728 12.9202 28.503 13.3355 29.0456 13.8477C29.6925 14.459 30.2193 15.213 30.6116 16.0897C31.1839 17.3697 31.0476 19.5259 30.938 21.2583L30.9335 21.3316C30.9228 21.5028 30.9125 21.667 30.9031 21.8268C30.9775 21.8606 31.0923 21.896 31.2561 21.9043C31.564 21.8898 31.9226 21.7876 32.323 21.6008C32.51 21.5138 32.7076 21.4955 32.841 21.4955C33.037 21.4955 33.2295 21.5322 33.3983 21.6018C33.898 21.7801 34.2121 22.1442 34.2201 22.5539C34.2233 22.7233 34.1721 22.982 33.9091 23.2521C33.6889 23.4787 33.3551 23.6782 32.8881 23.8621C32.7803 23.9046 32.6509 23.9456 32.5136 23.9887C32.0392 24.1389 31.3222 24.3658 31.1355 24.8045C31.0407 25.0275 31.0811 25.3201 31.256 25.6742C31.2609 25.6837 31.2655 25.6934 31.2696 25.7032C31.3334 25.8522 32.8751 29.3585 36.2975 29.9209C36.6001 29.9703 36.8163 30.2395 36.799 30.5443C36.7942 30.6341 36.7726 30.7224 36.7357 30.8075C36.6127 31.0915 36.3296 31.3335 35.8698 31.5461C35.3065 31.8069 34.4645 32.0259 33.366 32.1978C33.3109 32.3035 33.2517 32.5729 33.2143 32.7427L33.2137 32.7456C33.1709 32.9412 33.1275 33.1344 33.0667 33.3401C32.9752 33.6525 32.7355 33.831 32.4093 33.831H32.3943L32.3799 33.8308C32.232 33.8308 32.0393 33.8074 31.7913 33.7587C31.4113 33.6848 30.9857 33.6165 30.4482 33.6165C30.1361 33.6165 29.8128 33.6439 29.4876 33.6978C28.8607 33.8018 28.3206 34.182 27.695 34.6224L27.6945 34.6228L27.693 34.6241L27.6924 34.6245C26.7778 35.2694 25.7415 36 24.1576 36C24.0891 36 24.0242 35.9981 23.9719 35.9956C23.9291 35.9986 23.8858 36 23.8426 36C22.2588 36 21.2221 35.2694 20.3063 34.6239C19.6806 34.1828 19.1399 33.8019 18.5126 33.6978C18.1872 33.6438 17.8639 33.6165 17.5519 33.6165C16.9893 33.6165 16.5385 33.7044 16.2088 33.7689L16.2012 33.7704C15.9793 33.8133 15.7874 33.8504 15.6203 33.8504C15.1742 33.8504 15.0006 33.5784 14.9337 33.3508C14.8717 33.1407 14.8281 32.9429 14.7864 32.7505L14.7841 32.7401C14.7443 32.5595 14.6879 32.3032 14.6335 32.2C13.5357 32.0284 12.6934 31.8089 12.1302 31.5481C11.6693 31.3344 11.3858 31.0922 11.2635 30.807L11.2627 30.8055C11.2268 30.7206 11.2061 30.6329 11.2009 30.5449C11.1841 30.2396 11.4 29.971 11.7024 29.9215C12.4725 29.795 13.2074 29.5089 13.8866 29.0712C14.4431 28.7126 14.9668 28.2509 15.4422 27.6984C16.2789 26.7268 16.6867 25.8056 16.7305 25.7038C16.7341 25.6952 16.738 25.687 16.742 25.6786L16.7438 25.6748C16.9188 25.3207 16.9596 25.0278 16.8647 24.8052C16.6779 24.3666 15.9618 24.1397 15.4877 23.9895L15.4862 23.989L15.4844 23.9884C15.3485 23.9454 15.2201 23.9049 15.1119 23.8624C14.6978 23.6992 14.377 23.5157 14.1586 23.3167C13.7615 22.9552 13.7599 22.5988 13.7942 22.4185C13.8464 22.1459 14.0384 21.9 14.3355 21.726C14.5717 21.5876 14.844 21.5118 15.1023 21.5118C15.263 21.5118 15.4087 21.5417 15.5363 21.601C15.9702 21.8037 16.3539 21.9066 16.6766 21.9066C16.8772 21.9066 17.0132 21.866 17.0971 21.8276C17.087 21.6571 17.076 21.4826 17.0654 21.3137L17.062 21.2599L17.0616 21.2572L17.0615 21.2565C16.9525 19.5252 16.8168 17.3712 17.3888 16.0922C17.7794 15.2186 18.3043 14.4666 18.9487 13.8566C19.4891 13.3446 20.1172 12.9294 20.8156 12.6222C22.037 12.0847 23.174 12.0046 23.7423 12.0046L24.1824 12.0003C24.2022 12 24.2229 12 24.245 12Z"
        fill="black"
      />
    </svg>
  );
};

export const RecordIcon = (props: any) => {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.8335"
        y="16"
        width="34.6667"
        height="32"
        rx="2"
        fill="#2A2A2A"
      />
      <path
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.4593 17.7071C58.0893 17.0772 59.1664 17.5233 59.1664 18.4142V45.5858C59.1664 46.4767 58.0893 46.9229 57.4593 46.2929L43.8735 32.7071C43.483 32.3166 43.483 31.6834 43.8735 31.2929L57.4593 17.7071Z"
        fill="#2A2A2A"
      />
    </svg>
  );
};

export const ArrowLeftIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 20}
      height={props?.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M16.6663 10.75C17.0806 10.75 17.4163 10.4142 17.4163 10C17.4163 9.58579 17.0806 9.25 16.6663 9.25V10.75ZM16.6663 9.25H3.33301V10.75H16.6663V9.25Z"
        fill={props?.fill ?? "#1C274C"}
      />
      <path
        d="M8.33301 5L3.33301 10L8.33301 15"
        stroke={props?.stroke ?? "#1C274C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const KebabIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 14.3508C6.10457 14.3508 7 13.4942 7 12.4376C7 11.381 6.10457 10.5244 5 10.5244C3.89543 10.5244 3 11.381 3 12.4376C3 13.4942 3.89543 14.3508 5 14.3508Z"
        fill="#2A2A2A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 14.3508C13.1046 14.3508 14 13.4942 14 12.4376C14 11.381 13.1046 10.5244 12 10.5244C10.8954 10.5244 10 11.381 10 12.4376C10 13.4942 10.8954 14.3508 12 14.3508Z"
        fill="#2A2A2A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 14.3508C20.1046 14.3508 21 13.4942 21 12.4376C21 11.381 20.1046 10.5244 19 10.5244C17.8954 10.5244 17 11.381 17 12.4376C17 13.4942 17.8954 14.3508 19 14.3508Z"
        fill="#2A2A2A"
      />
    </svg>
  );
};

export const CheckCircle = (props: any) => {
  return (
    <svg
      width={props?.width ?? 20}
      height={props?.height ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4221_3791)">
        <circle
          cx="10.0003"
          cy="10.0001"
          r="8.33333"
          stroke="#777777"
          strokeWidth="1.5"
        />
        <path
          d="M7.08301 10.4167L8.74967 12.0834L12.9163 7.91675"
          stroke="#777777"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4221_3791">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CameraIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="13" r="3" stroke="#1C274C" stroke-width="1.5" />
      <path
        d="M10.0001 19.9999H14.0001C16.809 19.9999 18.2135 19.9999 19.2224 19.3258C19.6591 19.0339 20.0341 18.6589 20.326 18.2222C21.0001 17.2133 21.0001 15.8088 21.0001 12.9999C21.0001 10.191 21 8.78673 20.3258 7.77783C20.034 7.34107 19.659 6.96607 19.2222 6.67423C18.2133 6.00011 16.8089 6.00011 14 6.00011H9.99995C7.19103 6.00011 5.78656 6.00011 4.77767 6.67423C4.34091 6.96607 3.96591 7.34107 3.67407 7.77783C3.0001 8.7865 3.0001 10.1903 3.0001 12.998L3.0001 12.9999C3.0001 15.8088 3.0001 17.2133 3.67422 18.2222C3.96605 18.6589 4.34106 19.0339 4.77782 19.3258C5.78671 19.9999 7.19117 19.9999 10.0001 19.9999Z"
        stroke="#1C274C"
        strokeWidth="1.5"
      />
      <path
        d="M18 10H17.5"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.5 3.5H9.5"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CloseIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75781 17.2428L12.0008 11.9998L17.2438 17.2428M17.2438 6.75684L11.9998 11.9998L6.75781 6.75684"
        stroke={props?.stroke ?? "black"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TrashIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6.52381C3 6.12932 3.32671 5.80952 3.72973 5.80952H8.51787C8.52437 4.9683 8.61554 3.81504 9.45037 3.01668C10.1074 2.38839 11.0081 2 12 2C12.9919 2 13.8926 2.38839 14.5496 3.01668C15.3844 3.81504 15.4756 4.9683 15.4821 5.80952H20.2703C20.6733 5.80952 21 6.12932 21 6.52381C21 6.9183 20.6733 7.2381 20.2703 7.2381H3.72973C3.32671 7.2381 3 6.9183 3 6.52381Z"
        fill={props?.fill ?? "#1C274C"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5956 22H12.4044C15.1871 22 16.5785 22 17.4831 21.1141C18.3878 20.2281 18.4803 18.7749 18.6654 15.8685L18.9321 11.6806C19.0326 10.1036 19.0828 9.31511 18.6289 8.81545C18.1751 8.31579 17.4087 8.31579 15.876 8.31579H8.12404C6.59127 8.31579 5.82488 8.31579 5.37105 8.81545C4.91722 9.31511 4.96744 10.1036 5.06788 11.6806L5.33459 15.8685C5.5197 18.7749 5.61225 20.2281 6.51689 21.1141C7.42153 22 8.81289 22 11.5956 22ZM10.2463 12.1885C10.2051 11.7546 9.83753 11.4381 9.42537 11.4815C9.01321 11.5249 8.71251 11.9117 8.75372 12.3456L9.25372 17.6087C9.29494 18.0426 9.66247 18.3591 10.0746 18.3157C10.4868 18.2724 10.7875 17.8855 10.7463 17.4516L10.2463 12.1885ZM14.5746 11.4815C14.9868 11.5249 15.2875 11.9117 15.2463 12.3456L14.7463 17.6087C14.7051 18.0426 14.3375 18.3591 13.9254 18.3157C13.5132 18.2724 13.2125 17.8855 13.2537 17.4516L13.7537 12.1885C13.7949 11.7546 14.1625 11.4381 14.5746 11.4815Z"
        fill={props?.fill ?? "#1C274C"}
      />
    </svg>
  );
};

export const AltArrowLeftIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 5L9 12L15 19"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CalendarIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12C2 8.22876 2 6.34315 3.17157 5.17157C4.34315 4 6.22876 4 10 4H14C17.7712 4 19.6569 4 20.8284 5.17157C22 6.34315 22 8.22876 22 12V14C22 17.7712 22 19.6569 20.8284 20.8284C19.6569 22 17.7712 22 14 22H10C6.22876 22 4.34315 22 3.17157 20.8284C2 19.6569 2 17.7712 2 14V12Z"
        stroke="#1C274C"
        strokeWidth="1.5"
      />
      <path
        d="M7 4V2.5"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17 4V2.5"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M2.5 9H21.5"
        stroke="#1C274C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 16.4477 16.4477 16 17 16C17.5523 16 18 16.4477 18 17Z"
        fill="#1C274C"
      />
      <path
        d="M18 13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13C16 12.4477 16.4477 12 17 12C17.5523 12 18 12.4477 18 13Z"
        fill="#1C274C"
      />
      <path
        d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
        fill="#1C274C"
      />
      <path
        d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z"
        fill="#1C274C"
      />
      <path
        d="M8 17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16C7.55228 16 8 16.4477 8 17Z"
        fill="#1C274C"
      />
      <path
        d="M8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12C7.55228 12 8 12.4477 8 13Z"
        fill="#1C274C"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16602 15.167C2.16602 14.8908 2.38987 14.667 2.66602 14.667H13.3327C13.6088 14.667 13.8327 14.8908 13.8327 15.167C13.8327 15.4431 13.6088 15.667 13.3327 15.667H2.66602C2.38987 15.667 2.16602 15.4431 2.16602 15.167Z"
        fill="#2A2A2A"
      />
      <path
        d="M7.67939 10.4523L7.6794 10.4523L11.6239 6.50784C11.087 6.28441 10.4512 5.91738 9.84983 5.31604C9.24839 4.7146 8.88135 4.07865 8.65792 3.54176L4.71339 7.48629L4.71338 7.4863C4.40557 7.79411 4.25166 7.94802 4.11929 8.11772C3.96315 8.31791 3.82929 8.53451 3.72006 8.76369C3.62747 8.95797 3.55864 9.16446 3.42098 9.57745L2.69505 11.7552C2.62731 11.9585 2.6802 12.1825 2.83169 12.334C2.98317 12.4855 3.20723 12.5384 3.41046 12.4706L5.58824 11.7447C6.00122 11.6071 6.20772 11.5382 6.402 11.4456C6.63118 11.3364 6.84778 11.2025 7.04797 11.0464C7.21767 10.914 7.37159 10.7601 7.67939 10.4523Z"
        fill="#2A2A2A"
      />
      <path
        d="M12.7184 5.4133C13.5374 4.59426 13.5374 3.26633 12.7184 2.44729C11.8994 1.62825 10.5714 1.62825 9.75239 2.44729L9.2793 2.92038C9.28578 2.93994 9.2925 2.95977 9.29947 2.97986C9.47287 3.47967 9.80004 4.13488 10.4155 4.75035C11.031 5.36583 11.6862 5.693 12.186 5.8664C12.206 5.87334 12.2257 5.88003 12.2452 5.88648L12.7184 5.4133Z"
        fill="#2A2A2A"
      />
    </svg>
  );
};

// export const CheckCircle = (props: any) => {
//   return (
//     <svg
//       width={props?.width ?? 20}
//       height={props?.height ?? 20}
//       viewBox="0 0 20 20"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <g clipPath="url(#clip0_4221_3791)">
//         <circle
//           cx="10.0003"
//           cy="10.0001"
//           r="8.33333"
//           stroke="#777777"
//           strokeWidth="1.5"
//         />
//         <path
//           d="M7.08301 10.4167L8.74967 12.0834L12.9163 7.91675"
//           stroke="#777777"
//           strokeWidth="1.5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         />
//       </g>
//       <defs>
//         <clipPath id="clip0_4221_3791">
//           <rect width="20" height="20" fill="white" />
//         </clipPath>
//       </defs>
//     </svg>
//   );
// };

export const ShareIcon = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.21669 10.9073C6.97455 10.4716 6.59459 10.1286 6.13646 9.93227C5.67832 9.73589 5.16794 9.69719 4.68544 9.82226C4.20293 9.94733 3.77562 10.2291 3.47057 10.6233C3.16552 11.0175 3 11.5018 3 12.0003C3 12.4987 3.16552 12.9831 3.47057 13.3773C3.77562 13.7715 4.20293 14.0532 4.68544 14.1783C5.16794 14.3034 5.67832 14.2647 6.13646 14.0683C6.59459 13.8719 6.97455 13.529 7.21669 13.0933M7.21669 10.9073C7.39669 11.2313 7.49969 11.6033 7.49969 12.0003C7.49969 12.3973 7.39669 12.7703 7.21669 13.0933M7.21669 10.9073L16.7827 5.59328M7.21669 13.0933L16.7827 18.4073M16.7827 5.59328C16.9229 5.85742 17.1144 6.09095 17.346 6.28021C17.5776 6.46947 17.8445 6.61068 18.1313 6.69556C18.4181 6.78044 18.7189 6.80731 19.0161 6.77458C19.3134 6.74185 19.6012 6.65018 19.8626 6.50494C20.124 6.35971 20.3539 6.1638 20.5387 5.9287C20.7236 5.69359 20.8597 5.42399 20.9391 5.13567C21.0185 4.84734 21.0397 4.54607 21.0013 4.24948C20.963 3.95288 20.8659 3.66691 20.7157 3.40828C20.4198 2.89862 19.9357 2.52542 19.3675 2.3689C18.7993 2.21237 18.1924 2.28503 17.6772 2.57124C17.162 2.85745 16.7797 3.33437 16.6124 3.89948C16.4452 4.46459 16.5063 5.07277 16.7827 5.59328ZM16.7827 18.4073C16.6392 18.6657 16.5479 18.9498 16.5142 19.2434C16.4804 19.537 16.5049 19.8345 16.5861 20.1186C16.6673 20.4028 16.8037 20.6683 16.9875 20.8997C17.1712 21.1312 17.3988 21.3242 17.6572 21.4678C17.9156 21.6113 18.1997 21.7026 18.4933 21.7363C18.787 21.77 19.0844 21.7456 19.3685 21.6644C19.6527 21.5832 19.9182 21.4468 20.1496 21.263C20.3811 21.0792 20.5742 20.8517 20.7177 20.5933C21.0076 20.0715 21.0783 19.4559 20.9143 18.8819C20.7503 18.308 20.365 17.8227 19.8432 17.5328C19.3214 17.2429 18.7058 17.1722 18.1318 17.3362C17.5579 17.5002 17.0726 17.8855 16.7827 18.4073Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Copy = (props: any) => {
  return (
    <svg
      width={props?.width ?? 24}
      height={props?.height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 17.25V20.625C15.75 21.246 15.246 21.75 14.625 21.75H4.875C4.57663 21.75 4.29048 21.6315 4.0795 21.4205C3.86853 21.2095 3.75 20.9234 3.75 20.625V7.875C3.75 7.254 4.254 6.75 4.875 6.75H6.75C7.25257 6.74966 7.7543 6.79114 8.25 6.874M15.75 17.25H19.125C19.746 17.25 20.25 16.746 20.25 16.125V11.25C20.25 6.79 17.007 3.089 12.75 2.374C12.2543 2.29114 11.7526 2.24966 11.25 2.25H9.375C8.754 2.25 8.25 2.754 8.25 3.375V6.874M15.75 17.25H9.375C9.07663 17.25 8.79048 17.1315 8.5795 16.9205C8.36853 16.7095 8.25 16.4234 8.25 16.125V6.874M20.25 13.5V11.625C20.25 10.7299 19.8944 9.87145 19.2615 9.23852C18.6286 8.60558 17.7701 8.25 16.875 8.25H15.375C15.0766 8.25 14.7905 8.13148 14.5795 7.9205C14.3685 7.70952 14.25 7.42337 14.25 7.125V5.625C14.25 5.18179 14.1627 4.74292 13.9931 4.33345C13.8235 3.92397 13.5749 3.55191 13.2615 3.23852C12.9481 2.92512 12.576 2.67652 12.1666 2.50691C11.7571 2.3373 11.3182 2.25 10.875 2.25H9.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Facebook = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 32}
      height={props?.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.16337 0 16C0 23.986 5.851 30.6054 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5434 6.25C21.294 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.1198 10.5 18.5 11.7334 18.5 12.9987V16H22.9375L22.2281 20.625H18.5V31.8056C26.149 30.6054 32 23.9861 32 16Z"
        fill="#1877F2"
      />
      <path
        d="M22.2281 20.625L22.9375 16H18.5V12.9987C18.5 11.7332 19.1199 10.5 21.1075 10.5H23.125V6.5625C23.125 6.5625 21.294 6.25 19.5434 6.25C15.8888 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C14.327 31.9352 15.1629 32.0002 16 32C16.8371 32.0002 17.673 31.9353 18.5 31.8056V20.625H22.2281Z"
        fill="white"
      />
    </svg>
  );
};
export const Twitter = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ?? 32}
      height={props?.height ?? 32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M28.724 9.47204C28.7435 9.75429 28.7435 10.0363 28.7435 10.321C28.7435 18.996 22.1393 29.001 10.0635 29.001V28.996C6.49602 29.001 3.00248 27.9792 0 26.0525C0.51875 26.115 1.04 26.1463 1.5625 26.1475C4.51928 26.1499 7.39101 25.1582 9.71625 23.3318C8.34624 23.3059 7.01857 22.8525 5.91886 22.0351C4.81915 21.2176 4.00238 20.077 3.58275 18.7725C4.567 18.9625 5.581 18.9233 6.547 18.6593C3.484 18.0405 1.2805 15.3495 1.2805 12.2243V12.141C2.19358 12.6497 3.21551 12.9315 4.26025 12.9628C1.375 11.0348 0.48625 7.19704 2.22825 4.19679C3.87647 6.22495 5.9329 7.88372 8.26396 9.06536C10.595 10.247 13.1486 10.9251 15.7587 11.0555C15.4986 9.93523 15.5371 8.76625 15.8704 7.66549C16.2038 6.56474 16.8203 5.57078 17.6583 4.78304C20.3025 2.29729 24.4613 2.42479 26.9468 5.06779C28.4171 4.77747 29.827 4.2384 31.116 3.47379C30.6259 4.99396 29.6003 6.28438 28.23 7.10504C29.5314 6.95159 30.8023 6.6031 32 6.07129C31.119 7.39069 30.0096 8.54232 28.724 9.47204Z"
        fill={props?.fill ?? "#1D9BF0"}
      />
    </svg>
  );
};

